import Vue from 'vue'
import SearchForm from './components/SearchForm.vue'
import SocialSharing from 'vue-social-sharing'
import SocialSharingLink from './components/SocialSharingLink.vue'


const {
  __,
  _x,
  _nx,
  sprintf,
} = wp.i18n

export default (() => {
  Vue.use(SocialSharing);
  Vue.component('search-form', SearchForm);
  Vue.component('social-sharing-link', SocialSharingLink);

  // Add WP translations function to vue
  Vue.mixin({
    methods: {
        __,
        _x,
        _nx,
        sprintf,
    },
  });

  new Vue({
    el: '#app',
    data: {},
  })
})();


// WEBPACK FOOTER //
// ./scripts/vueApp.js